'use client';

import { logger } from '@curology/logger/client';
import { useEffect } from 'react';

import ContactSupportError from '@/components/global/errors/contactSupportError';
import ErrorNavBar from '@/components/global/errors/errorNavBar';

const Error = ({ error }: { error: Error; reset: () => void }) => {
  useEffect(() => {
    logger.error(`Error caught by root ErrorBoundary: ${error}`);
  }, [error]);

  return (
    <>
      <ErrorNavBar />
      <ContactSupportError />
    </>
  );
};

export default Error;
